import script from "./AcompanhamentoAbates_44.vue?vue&type=script&setup=true&lang=js"
export * from "./AcompanhamentoAbates_44.vue?vue&type=script&setup=true&lang=js"

import "./AcompanhamentoAbates_44.vue?vue&type=style&index=0&id=1b42ad4d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b42ad4d"]])

export default __exports__